import { Component, Input, OnInit, EventEmitter, Output, OnChanges ,inject, DestroyRef, ViewChild, Renderer2 } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { translate } from '@jsverse/transloco';
import { ManageColumnsComponent } from 'src/app/components/manage-columns/manage-columns.component';
import { MatDialog } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RouterSegments } from 'src/app/models/router-segments';
import { EditRunbookService } from 'src/app/services/api/edit-runbook.service';
import { EnvSchedulePopupComponent } from 'src/app/components/env-schedule-popup-component/env-schedule-popup-component';
import { RunbookPopupComponent } from '../environment-runbook/runbook-popup/runbook-popup.component';
import { CRVTService } from 'src/app/services/api/crvt.service';
import { UrlService } from 'src/app/services/util/url.service';
import { ConfigurationState } from 'src/app/models/configurations/configuration-state';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Permissions, Datazone, Attributes } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DbBackupDetailsComponent } from 'src/app/components/instance-details/db-backup-details/db-backup-details.component';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { DatabaseBackupComponent } from 'src/app/components/database-backup/database-backup.component';
import { DbbackupService } from 'src/app/services/api/dbbackup.service';
import { DbBackupFormComponent } from 'src/app/components/instance-details/db-backup-form/db-backup-form.component';
import { InstancesService } from 'src/app/services/api/instances.service';
import { CloudResourcesInventoryComponent } from 'src/app/components/instance-details/cloud-resources-inventory/cloud-resources-inventory.component';
import { TimeDurationPipe } from 'src/app/pipes/timeDuration.pipe';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { EnvScheduleService } from 'src/app/services/api/env-schedule.service';
import { RunbookService } from 'src/app/services/api/runbook.service';
import { TitleCasePipe } from '@angular/common';
import { DurationPipe } from 'src/app/pipes/duration.pipe';
import { UpdateRunbookVersionComponent } from '../environment-runbook/update-runbook-version/update-runbook-version.component';
import { LocalConfiguration } from 'src/app/services/api/local-config.service';
import { ActivityProgressService } from 'src/app/services/util/activity-progress.service';
import { RedirectionDialogComponent } from 'src/app/components/redirection-dialog/redirection-dialog.component';
import { Constants } from 'src/app/models/constants';

const REQUIRED_PERMISSIONS = [
  {
      key: PermissionKeys.RUNBOOK_CREATE_NONPII,
      action: Permissions.RUNBOOK_CREATE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.NONPII
  },
  {
      key: PermissionKeys.RUNBOOK_UPDATE_NONPII,
      action: Permissions.RUNBOOK_UPDATE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.NONPII
    },
    {
      key: PermissionKeys.RUNBOOK_DELETE_NONPII,
      action: Permissions.RUNBOOK_DELETE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.NONPII
    },
    {
        key: PermissionKeys.RUNBOOK_CREATE_PII,
        action: Permissions.RUNBOOK_CREATE,
        attribute: Attributes.DATAZONE,
        attributeValue: Datazone.PII
    },
    {
        key: PermissionKeys.RUNBOOK_UPDATE_PII,
        action: Permissions.RUNBOOK_UPDATE,
        attribute: Attributes.DATAZONE,
        attributeValue: Datazone.PII
    },
    {
        key: PermissionKeys.RUNBOOK_DELETE_PII,
        action: Permissions.RUNBOOK_DELETE,
        attribute: Attributes.DATAZONE,
        attributeValue: Datazone.PII
    },
    {
        key: PermissionKeys.RUNBOOK_CREATE_LIVE,
        action: Permissions.RUNBOOK_CREATE,
        attribute: Attributes.DATAZONE,
        attributeValue: Datazone.LIVE
    },
    {
        key: PermissionKeys.RUNBOOK_UPDATE_LIVE,
        action: Permissions.RUNBOOK_UPDATE,
        attribute: Attributes.DATAZONE,
        attributeValue: Datazone.LIVE
    },
    {
        key: PermissionKeys.RUNBOOK_DELETE_LIVE,
        action: Permissions.RUNBOOK_DELETE,
        attribute: Attributes.DATAZONE,
        attributeValue: Datazone.LIVE
    },
    {
      key: PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_NONPII,
      action: Permissions.INSTANCE_SFTP_CONFIG,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.NONPII
    },
    {
      key: PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_PII,
      action: Permissions.INSTANCE_SFTP_CONFIG,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.PII
    },
    {
      key: PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_LIVE,
      action: Permissions.INSTANCE_SFTP_CONFIG,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.LIVE
    },
    {
      key: PermissionKeys.SCHEDULE_UPDATE_NONPII,
      action: Permissions.AWS_SCHEDULE_UPDATE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.NONPII
    },
    {
      key: PermissionKeys.SCHEDULE_UPDATE_PII,
      action: Permissions. AWS_SCHEDULE_UPDATE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.PII
    },
    {
      key: PermissionKeys.SCHEDULE_UPDATE_LIVE,
      action: Permissions. AWS_SCHEDULE_UPDATE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.LIVE
   },
   {
      key: PermissionKeys.SCHEDULE_DELETE_NONPII,
      action: Permissions.AWS_SCHEDULE_DELETE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.NONPII
    },
    {
      key: PermissionKeys.SCHEDULE_DELETE_PII,
      action: Permissions. AWS_SCHEDULE_DELETE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.PII
    },
    {
      key: PermissionKeys.SCHEDULE_DELETE_LIVE,
      action: Permissions. AWS_SCHEDULE_DELETE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.LIVE
   },
   {
      key: PermissionKeys.SIZING_READ_NONPII,
      action: Permissions. SIZING_READ,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.NONPII
   },
   {
      key: PermissionKeys.SIZING_READ_PII,
      action: Permissions. SIZING_READ,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.PII
   },
   {
      key: PermissionKeys.SIZING_READ_LIVE,
      action: Permissions. SIZING_READ,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.LIVE
   },
   {
      key: PermissionKeys.SIZING_UPDATE_NONPII,
      action: Permissions. SIZING_UPDATE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.NONPII
   },
   {
      key: PermissionKeys.SIZING_UPDATE_PII,
      action: Permissions. SIZING_UPDATE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.PII
   },
   {
      key: PermissionKeys.SIZING_UPDATE_LIVE,
      action: Permissions. SIZING_UPDATE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.LIVE
   },
   {
      key: PermissionKeys.SIZING_DELETE_NONPII,
      action: Permissions. SIZING_DELETE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.NONPII
   },
   {
      key: PermissionKeys.SIZING_DELETE_PII,
      action: Permissions. SIZING_DELETE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.PII
   },
   {
      key: PermissionKeys.SIZING_DELETE_LIVE,
      action: Permissions. SIZING_DELETE,
      attribute: Attributes.DATAZONE,
      attributeValue: Datazone.LIVE
   }

];

@Component({
    selector: 'app-environment-table',
    templateUrl: './environment-table.component.html',
    styleUrl: './environment-table.component.scss',
    providers: [TimeDurationPipe, DurationPipe],
     animations: [
      trigger('detailExpand', [
          state('collapsed', style({ height: '0px', minHeight: '0' })),
          state('expanded', style({ height: '*' })),
          transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      ]),
    ],
    standalone: false
})
export class EnvironmentTableComponent implements OnInit {
  @ViewChild(MatTable) table!: MatTable<any>;
  private destroyRef = inject(DestroyRef);
  currentTime: number = Date.now();
  private progressTimer: any;
  @Input() displayColumns;
  @Input() set initialDataSource(data) {
    this.initialData = data;
    this.dataSource = this.initialData;
    this.searchAndSort();
  };
  @Input() dataLoading;
  @Input() showSkeletonLoader;
  @Input() initialCreate;
  @Input() dataSourceLength;
  @Input() instance;
  @Input() pageName;
  @Input() page;
  @Input() instanceName;
  @Input() showStageInfoIcon = false;
  @Input() routeWithExpiration: any[];
  @Input() sftpEncKeyRotation: boolean;
  @Input() data: any;
  @Input() set searchTerm(value: string) {
  this.searchText = value;
  if (this.initialData?.length) {
    this.searchAndSort();
  }
}
  @Input() innerTableColumns;
  @Output() searchedResults = new EventEmitter();
  @Output() totalRecords = new EventEmitter<number>();
  @Output() sorted = new EventEmitter<void>();
  @Output() pageModify = new EventEmitter<any>();
  @Output() approve = new EventEmitter();
  @Output() rowClicked = new EventEmitter();
  @Output() goToJobs = new EventEmitter<any>();
  @Output() editScheduleEmit = new EventEmitter();
  @Output() redeploy = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() openSftpForm = new EventEmitter();
  @Output() viewSshKey = new EventEmitter();
  @Output() editKey = new EventEmitter();
  @Output() editRouteData = new EventEmitter();
  @Output() viewClickKubernetes = new EventEmitter();
  @Output() configNameClick = new EventEmitter();
  @Output() deleteScheduleEmit = new EventEmitter();
  @Output() deleteRunbookEmit = new EventEmitter();
  @Output() selectRow = new EventEmitter();
  @Output() downloadPackage = new EventEmitter();
  @Output() applyPackageConfig= new EventEmitter();
  @Output() executeRvtTest = new EventEmitter();
  @Output() updateRunbookEmit = new EventEmitter();
  @Output() deleteSizingData = new EventEmitter();
  @Output() applyLocalConfig = new EventEmitter();
  @Output() versionClick = new EventEmitter();
  @Output() applySizingDoc = new EventEmitter();
  @Input() datazone: any;
  @Output() editSizingData = new EventEmitter();
  @Output() arrowClicked = new EventEmitter<any>();
  @Output() retryBaseImage = new EventEmitter<any>();
  @Output() nameClick = new EventEmitter<any>();
  @Output() thresholdClick = new EventEmitter<any>();
  @Input() noDataMessage;

  isRefreshing = false;
  runbook: any;
  runbookLoading = true;
  searchText: string;
  initialData: any;
  sortDetails: any;
  dataSource: any;
  allColumns: any;
  isEditRunbookAllowed:boolean;
  RouterSegments = RouterSegments;
  PermissionKeys = PermissionKeys;
  isScheduleAllowed: boolean;
  isEditSizingAllowed: boolean;
  isDeleteSizingAllowed: boolean;

  columnHeaders: any;
  showPagination = true;
  pageIndex = 0;
  paginationSize = 10;
  pageDataSource: any;
  inprogressStatus = ['started','inprogress', 'deleting', 'approving', 'rejecting', 'running', 'adding', 'removing', 'updating', 'preparing', 'promoting', 'creating', 'deploying', 'configuring', 'Executing RVTs','Applying Configuration', 'Testing Update',' Verifying Update','enabling', 'disabling'];
  failedStatus = ['failed', 'approval_failed', 'rejection_failed','Failed', 'preparation_failed', 'promotion_failed', 'config_failed', 'update_failed', 'deletion_failed', 'extention_failed','Test Failed','Update failed'];
  completedStatus = ['completed', 'published', 'approved', 'active', 'added', 'updated','success','Success', 'prepared', 'promoted', 'deployed', 'created', 'configured','verified', 'enabled', 'Deployed', 'Available'];
  expiredStatus = ['expired'];
  deletedStatus = ['deleted'];
  disabledStatus = ['disabled'];
  deleteFailedStatus = ['delete_failed'];
  editRunbookDisabledStates = ['inprogress', 'deleting', 'approving', 'rejecting', 'running', 'adding', 'removing', 'updating', 'preparing', 'promoting', 'creating', 'deploying', 'configuring','terminating', 'terminated','termination_failed']
  tenantId: any;

  isRunbookDeploying = false;
  clientName: any;
  permissionsMap: { [key: string]: boolean };
  instanceInprogress: boolean;
  isCreateRunbookAllowed: any;
  expandedElement: any;
  dbInprogess = false;
  backupResults: any = [];
  backupTable: any = [];
  databases: any;
  dataSourceInnerLog: any;
  innerColumnHeaders: any;
  isDeleteScheduleAllowed: boolean = false;
  packProgressStatus = ['Executing RVTs','Applying Configuration', 'Testing Update',' Verifying Update'];
  packFailedStatus =['Test Failed','Update failed']
  isDeleteRunbookAllowed = false;
  Constants = Constants;


  readonly INSTANCE_DEPLOYING_STATES = [DeployStatus.INITIALIZED, DeployStatus.INITIALIZING, DeployStatus.INITIALIZE_FAILED,
    DeployStatus.DEPLOYING, DeployStatus.TERMINATED, DeployStatus.TERMINATION_FAILED, DeployStatus.TERMINATING,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.TESTING, DeployStatus.FAILED,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING,
    DeployStatus.OPERATION_INPROGRESS, DeployStatus.TENANT_AGENT_CREATION_IN_PROGRESS, DeployStatus.START_FAILED, DeployStatus.STOP_FAILED, DeployStatus.STARTING,
    DeployStatus.STOPPING, DeployStatus.STOPPED, DeployStatus.STARTING_AGENT, DeployStatus.STOPPING_AGENT, DeployStatus.INPROGRESS];

  constructor(private instanceService: InstancesService, private dbBackupService: DbbackupService, private toastrService: CustomToastrService, private sidenavService: SidenavService, private dialog: MatDialog, public urlService: UrlService, private activatedRoute: ActivatedRoute, public router: Router, private crvtService: CRVTService, private editRunbookService: EditRunbookService,  public authService: AuthService,  private permissionsService: PermissionsService, private renderer: Renderer2,
    private tenantService: TenantService, private timeDuration: TimeDurationPipe, private envScheduleService: EnvScheduleService, private durationPipe: DurationPipe, private envRunbookService: RunbookService, private matDialog: MatDialog, private localConfig: LocalConfiguration,  public activityProgressService: ActivityProgressService
  ) {

  }

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'env-table-scroll');
     if (this.INSTANCE_DEPLOYING_STATES.includes(this.data?.status)) {
      this.instanceInprogress = true;
    } else {
      this.instanceInprogress = false;
    }
    this.tenantId = this.activatedRoute.snapshot.params.id;
    if(this.pageName === "sftpKey") {
      this.tenantService.getTenantDetails(this.tenantId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((data: any) => {
          if(data?.sharedServices?.pii?.sftpEncKeyRotation && (data?.sharedServices?.pii?.sftpEncKeyRotation === true || data?.sharedServices?.pii?.sftpEncKeyRotation === 'true')) {
            this.sftpEncKeyRotation = true;
          } else {
            this.sftpEncKeyRotation = false;
          }
        });
    }

    this.clientName = this.router.url.split('.')[0].split('/')[3];
    this.allColumns = [...this.displayColumns];
    this.displayTableColumns();
    this.columnHeaders = this.displayColumns?.map(item => item?.key);
    this.innerColumnHeaders = this.innerTableColumns?.map(item => item?.key);
    this.pageDataSource = new MatTableDataSource(this.dataSource?.slice(this.pageIndex, this.paginationSize));
    if(this.pageName === 'infraUpgrade' || this.pageName === 'activityDetails'){
    this.pageDataSource = new MatTableDataSource(this.dataSource);
    }
      this.progressTimer = setInterval(() => {
      this.currentTime = Date.now();
    }, 1000);
    this.checkRunbookDeploying();
    const dataZone = this.instance?.dataZone;
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.isCreateRunbookAllowed = (this.permissionsMap[PermissionKeys.RUNBOOK_CREATE_NONPII] && dataZone === Datazone.NONPII) || (this.permissionsMap[PermissionKeys.RUNBOOK_CREATE_PII] && dataZone === Datazone.PII) || (this.permissionsMap[PermissionKeys.RUNBOOK_CREATE_LIVE] && dataZone === Datazone.LIVE);
    this.isEditRunbookAllowed = (dataZone === Datazone.NONPII && this.permissionsMap[PermissionKeys.RUNBOOK_UPDATE_NONPII]) || (dataZone  === Datazone.PII && this.permissionsMap[PermissionKeys.RUNBOOK_UPDATE_PII]) || (dataZone  === DataZone.LIVE && this.permissionsMap[PermissionKeys.RUNBOOK_UPDATE_LIVE])
    this.isScheduleAllowed = (dataZone === Datazone.NONPII && this.permissionsMap[PermissionKeys.SCHEDULE_UPDATE_NONPII]) || (dataZone  === Datazone.PII && this.permissionsMap[PermissionKeys.SCHEDULE_UPDATE_PII]) || (dataZone  === DataZone.LIVE && this.permissionsMap[PermissionKeys.SCHEDULE_UPDATE_LIVE])
    this.isDeleteScheduleAllowed = (dataZone === Datazone.NONPII && this.permissionsMap[PermissionKeys.SCHEDULE_DELETE_NONPII]) || (dataZone  === Datazone.PII && this.permissionsMap[PermissionKeys.SCHEDULE_DELETE_PII]) || (dataZone  === DataZone.LIVE && this.permissionsMap[PermissionKeys.SCHEDULE_DELETE_LIVE]);
    this.isDeleteRunbookAllowed = (dataZone === Datazone.NONPII && this.permissionsMap[PermissionKeys.RUNBOOK_DELETE_NONPII]) || (dataZone  === Datazone.PII && this.permissionsMap[PermissionKeys.RUNBOOK_DELETE_PII]) || (dataZone  === DataZone.LIVE && this.permissionsMap[PermissionKeys.RUNBOOK_DELETE_LIVE]);
    this.isEditSizingAllowed = (this.permissionsMap[PermissionKeys.SIZING_UPDATE_NONPII] && this.datazone === Datazone.NONPII) || (this.permissionsMap[PermissionKeys.SIZING_UPDATE_PII] && this.datazone === Datazone.PII) || (this.permissionsMap[PermissionKeys.SIZING_UPDATE_LIVE] && this.datazone === Datazone.LIVE);
    this.isDeleteSizingAllowed = (this.permissionsMap[PermissionKeys.SIZING_DELETE_NONPII] && this.datazone === Datazone.NONPII) || (this.permissionsMap[PermissionKeys.SIZING_DELETE_PII] && this.datazone === Datazone.PII) || (this.permissionsMap[PermissionKeys.SIZING_DELETE_LIVE] && this.datazone === Datazone.LIVE);
  }

    checkRunbookDeploying() {
      this.isRunbookDeploying = this.dataSource.some(item => item.status === 'deploying' || item.status === 'configuring' || item.status === 'creating' || item.status === 'updating');
    }

   displayTableColumns(): void {
    this.displayColumns.map(item => item.name = item.name?.includes('.') ? translate(item.name) : item.name);
    this.displayColumns = this.displayColumns.filter(item => item.visible === true || item.key === 'runbookSettings' || item.key === 'scheduleSettings' || item.key === 'sftpSettings' || item.key === 'sftpKeySettings' || item.key === 'activitySettings' ||item.key === 'sanityTestSettings' || item.key === 'localConfigsettings' || item.key === 'updateManagerSettings');
    this.columnHeaders = this.displayColumns?.map(item => item?.key);
    document.documentElement.style.setProperty( '--colCount',
    this.columnHeaders.length.toString()
    );
    this.pageDataSource = new MatTableDataSource(this.dataSource?.slice(this.pageIndex, this.paginationSize));
     if(this.pageName === 'infraUpgrade' || this.pageName === 'activityDetails'){
    this.pageDataSource = new MatTableDataSource(this.dataSource);
    }
    this.table?.renderRows();
   }

   get isEmptyTable(): boolean {
    return !this.dataLoading && (!this.pageDataSource || this.pageDataSource.data.length === 0);
   }

  searchAndSort() {
  const searchBy = this.searchText?.trim().toLowerCase() || '';

  if (!searchBy) {
    this.dataSource = Array.isArray(this.initialData) ? [...this.initialData] : [];
  } else {
    const allColKeys = new Set(this.displayColumns.map(col => col.key));
    const dateCols = new Set(this.displayColumns.filter(col => col.type === 'date').map(col => col.key));
    const dateWithoutTimeCols = new Set(this.displayColumns.filter(col => col.type === 'dateWithoutTime').map(col => col.key));
    const durationCols  = this.displayColumns.filter(col => col.startKey && col.endKey).map(col => ({startKey: col.startKey,endKey: col.endKey}));
    this.dataSource = this.initialData?.filter(item => {
      const normalized = Object.entries(item).map(([key, val]) => {
        let normalizedVal: string = '';
        // check string/normal columns
        if (allColKeys.has(key) && !dateCols.has(key) && !dateWithoutTimeCols.has(key) && !durationCols.some(d => d.startKey === key || d.endKey === key)) {
          normalizedVal = String(val ?? '');
          if (normalizedVal.toLowerCase().includes(searchBy)) {
            return normalizedVal.toLowerCase();
          }
        }
        // check date/dateWithoutTime columns
        if ((dateCols.has(key) || dateWithoutTimeCols.has(key)) && (typeof val === 'string' || typeof val === 'number' || val instanceof Date)) {
          const date = new Date(val);
          if (!isNaN(date.getTime())) {
            if (dateCols.has(key)) {
              if (['releasePackView', 'releasePackage', 'rvtPackage'].includes(this.pageName)) {
                // Format: dd MMM yy HH:mm:ss +0000 (UTC offset)
                const formatted = date.toLocaleString('en-GB', {day: '2-digit',month: 'short',year: '2-digit',
                  hour: '2-digit',minute: '2-digit',second: '2-digit',hour12: false,timeZone: 'UTC'}).replace(',', '');
                const offset = '+0000';
                normalizedVal = `${formatted} ${offset}`;
              } else {
                normalizedVal = date.toLocaleString('en-GB', {day: '2-digit', month: 'short', year: 'numeric',hour: '2-digit', minute: '2-digit', second: '2-digit',hour12: false}).replace(',', '');
              }
            } else { // dateWithoutTime
              normalizedVal = date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
            }
            if (normalizedVal.toLowerCase().includes(searchBy)) {
              return normalizedVal.toLowerCase();
            }
          }
        }
        // check duration columns
        const durationForKey = durationCols.find(d => d.startKey === key || d.endKey === key);
        if (durationForKey) {
          normalizedVal = this.pageName === 'releasePackView' ? this.durationPipe.transform(item[durationForKey.startKey], item[durationForKey.endKey], "") : this.timeDuration.transform(item[durationForKey.startKey], item[durationForKey.endKey], "");
          return normalizedVal.toLowerCase();
        }
      }).join(' ');
      return normalized.includes(searchBy);
    }) || [];
  }

  this.pageIndex = 0;
  this.pageDataSource = this.pageName === 'activityDetails' ? this.pageDataSource = new MatTableDataSource(this.dataSource) : new MatTableDataSource( this.dataSource.slice(this.pageIndex, this.pageIndex + this.paginationSize));

  this.searchedResults.emit(this.dataSource);
  this.totalRecords.emit(this.dataSource?.length || 0);
}

  sortData(event) {
    this.showPagination = false;
    setTimeout(() => {
      this.showPagination = true;
    }, 10);
    this.pageIndex = 0;
    this.sorted.emit();
    this.dataSource = this.dataSource?.sort((a, b) => {
      let comparatorResult = 0;
      let durationColumn = this.displayColumns.find(col => col.key === 'duration');
      let startKey = durationColumn?.startKey;
      let endKey   = durationColumn?.endKey;
      switch (event.active) {
        case 'name':
          comparatorResult = this.pageName === 'environmentBaseImage'
            ? String(a[event.active] ?? '').localeCompare(String(b[event.active] ?? ''), undefined, { numeric: true, sensitivity: 'base' })
            : this.compare(a[event.active], b[event.active]);
          break;
        case 'componentVersion':
        case 'status':
        case 'updatedAt':
        case 'lastExecutionTime':
        case 'nextExecutionTime':
        case 'scheduleName':
        case 'runbookName':
        case 'createdAt':
        case 'stageName':
        case 'startTime':
        case 'endTime':
        case 'expirationDate':
        case 'publicKey':
        case 'encEnabled':
        case 'direction':
        case 'routeId':
        case 'routeName':
        case 'pitrTimestamp':
        case 'ticketNumber':
        case 'dbName':
        case 'version':
        case 'image':
        case 'workload':
        case 'type':
        case 'kind':
        case 'skuData':
        case 'action':
        case 'finishTime':
        case 'jobId':
        case 'applicationStartTime':
        case 'applicationFinishTime':
        case 'testFinishTime':
        case 'testStartTime':
        case 'containerName':
        case 'isManaged':
        case 'start':
        case 'end':
        case 'dateGenerated':
        case 'buildName' :
        case 'createdAt' :
        case 'currentVersion':
        case 'latestVersion':
        case 'dateCreated':
        case 'componentName':
        case 'fromRef':
        case 'toRef':
        case 'destinationType':
          comparatorResult = this.compare(a[event.active],b[event.active]);
        break;
        case 'duration':
         comparatorResult = a?.[startKey] && b?.[startKey] && a?.[endKey] && b?.[endKey] ? this.timeDuration.transform(a?.[startKey], a?.[endKey], "")?.localeCompare(this.timeDuration.transform(b?.[startKey], b?.[endKey], "")) : !this.timeDuration.transform(b?.[startKey], b?.[endKey], "") ? -1 : 1;
         break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
     this.pageDataSource = new MatTableDataSource(this.dataSource?.slice(this.pageIndex, this.paginationSize));
     if(this.pageName === 'infraUpgrade' || this.pageName === 'activityDetails'){
      this.pageDataSource = new MatTableDataSource(this.dataSource);
      }
    }

  compare(data1: any, data2: any): number {
    if (data1 == null && data2 == null) return 0;
    if (data1 == null) return -1;
    if (data2 == null) return 1;

    const dateA = data1 instanceof Date ? data1 : new Date(data1);
    const dateB = data2 instanceof Date ? data2 : new Date(data2);

    if (!isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) {
      return dateA.getTime() - dateB.getTime();
    }

    if (!isNaN(data1) && !isNaN(data2)) {
      return data1 - data2;
    }

    return String(data1).localeCompare(String(data2), undefined, {
      numeric: true,
      sensitivity: 'base'
    });
}

hasErrors(data: any): boolean {
  return (
   ( Array.isArray(data?.errors) &&
    data.errors.some(group => Array.isArray(group) && group.length > 0) || (Array.isArray(data?.errors) && data.errors.length > 0))
  );
}

  public pageChanged(event): void {
  this.pageIndex = event.pageIndex;
  this.paginationSize = event.pageSize;
  const start = this.pageIndex * this.paginationSize;
  this.pageDataSource = new MatTableDataSource(
    this.dataSource.slice(start, start + this.paginationSize)
  );
  this.pageModify.emit(event);
}

radioClick(data): void {
  this.initialData.map(item => item.selected = false);
  if(this.pageName === 'environmentUpdateManager'){
   this.initialData.find(item => item.name === data.name).selected = !this.initialData.find(item => item.name === data.name).selected;
  }else{
  this.initialData.find(item => item.id === data.id).selected = !this.initialData.find(item => item.id === data.id).selected;
  }
  if (this.pageName === 'releasePackage' || this.pageName === 'rvtPackage'){
    this.selectRow.emit(data.configuration);
  }else if (this.pageName === 'localConfiguration') {
    this.selectRow.emit(data);
  }else {
    this.approve.emit(data);
  }
}

rvtClick(data): void {
  this.initialData.map(item => item.selected = false);
  this.initialData.find(item => item.id === data.id).selected = !this.initialData.find(item => item.id === data.id).selected;
  this.rowClicked.emit(data);
}

columnSettings(): void {
  this.openMenu();
  const previousSelection = [...this.allColumns];
      this.dialog.open(ManageColumnsComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '754px',
      autoFocus: false,
      data: {
        title: translate('MANAGE_COLUMNS.TITLE'),
        subTitle: translate('MANAGE_COLUMNS.SUBTITLE'),
        columns: this.allColumns,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(result => {
      if (result) {
         this.allColumns = [...result];
         this.displayColumns = [...result];
        this.displayTableColumns();
      } else {
        this.allColumns = [...previousSelection];
      }
    })
  }

  runbookPopup(data) {
    this.dialog.open(RunbookPopupComponent, {
    width: '950px',
    panelClass: 'default-dialog-wrapper',
    data: {
      runbook: data,
      name: this.instance?.name
    }
  });
  }

  editRunbook(data): void {
      this.editRunbookService.setData(data);
      this.editRunbookService.setIsEdit(true);
      this.editRunbookService.setInstance(this.instance);
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.tenantId, RouterSegments.BLUEPRINTS, this.activatedRoute.snapshot.params.blueprintId,
      RouterSegments.ENVIRONMENT, this.activatedRoute.snapshot.params.instanceId, RouterSegments.EDIT_RUNBOOK,data.id]);
    }

    createSchedule(data): void {
      this.editRunbookService.setData(data);
      this.editRunbookService.setIsEdit(true);
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.tenantId, RouterSegments.BLUEPRINTS, this.activatedRoute.snapshot.params.blueprintId,
      RouterSegments.ENVIRONMENT, this.activatedRoute.snapshot.params.instanceId, RouterSegments.CREATE_SCHEDULE]);
    }

    editSchedule(data): void {
      this.editScheduleEmit.emit(data);
    }

    /* Deletes the selected schedule after validating that no job is currently running for it. */
    deleteSchedule(schedule: any): void {
    this.envScheduleService.getInstanceJobs(this.activatedRoute.snapshot.params.instanceId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      const runningJob = res.data?.find((job: any) =>
        job.scheduleId === schedule.id && job.status === 'running'
      );
      const scheduleName = new TitleCasePipe().transform(schedule?.name);
      if (runningJob) {
         this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
              data: {
                title: translate('SCHEDULE.DELETE_NOT_ALLOWED'),
                description: translate('SCHEDULE.DELETE_RUNNING_JOB_WARNING', { scheduleName: scheduleName })
            }
        });
        return;
      }

      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('SCHEDULE.DELETE_SCHEDULE'),
          message: translate('SCHEDULE.DELETE_CONFIRMATION'),
          scheduleName: scheduleName,
          confirmButtonText: translate('BUTTONS.CONFIRM')
        }
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.envScheduleService
            .deleteSchedule(this.activatedRoute.snapshot.params.instanceId, schedule.id)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(results => {
              if (results) {
                this.deleteScheduleEmit.emit();
                setTimeout(() => {
                  const title = translate('SCHEDULE.SCHEDULE');
                  const message = translate('SCHEDULE.DELETE_SCHEDULE_TRIGGERED');
                  this.toastrService.successMessage(message, title);
                }, 500);
              }
            },
            (error) => {
              const errorMessage = typeof error === 'string' ? error : typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '280px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title: translate('SCHEDULE.SCHEDULE_DELETION_FAILED'),
                  description: errorMessage
                }
              });
            });
        }
      });
    });
}

/* Deletes the selected runbook after validating that no schedule is currently creating for it. */
deleteRunbook(runbook: any): void {
  this.envScheduleService.getSchedule(this.activatedRoute.snapshot.params.instanceId)
  .pipe(takeUntilDestroyed(this.destroyRef))
  .subscribe((res) => {
  const activeSchedule = res?.some((schedule: any) =>
      schedule.runbookId === runbook.id && schedule.status !== 'deleted' && schedule.status !== 'delete_failed'
    );
  const runbookName = new TitleCasePipe().transform(runbook?.name);
    if (activeSchedule) {
      const active = res.find((s: any) =>
        s.runbookId === runbook.id && s.status !== 'deleted' && s.status !== 'delete_failed'
      );

  const statusText = active?.status;
    this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
              data: {
                title: translate('RUNBOOK.DELETE_NOT_ALLOWED'),
                description: translate('RUNBOOK.DELETE_RUNNING_SCHEDULE_WARNING', { scheduleName: runbookName, status: statusText })
            }
        });
        return;
      }

      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('RUNBOOK.DELETE_RUNBOOK'),
          message: translate('RUNBOOK.DELETE_CONFIRMATION'),
          scheduleName: runbookName,
          confirmButtonText: translate('BUTTONS.CONFIRM')
        }
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.envRunbookService
            .deleteRunbook(this.activatedRoute.snapshot.params.instanceId, runbook.id)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(results => {
              if (results) {
                this.deleteRunbookEmit.emit();
                setTimeout(() => {
                  const title = translate('RUNBOOK.RUNBOOK');
                  const message = translate('RUNBOOK.DELETE_RUNBOOK_TRIGGERED');
                  this.toastrService.successMessage(message, title);
                }, 500);
              }
            },
            (error) => {
              const errorMessage = typeof error === 'string' ? error : typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '280px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title: translate('RUNBOOK.RUNBOOK_DELETION_FAILED'),
                  description: errorMessage
                }
              });
            });
        }
      });
  });
}

downloadCobReport(data): void {
    const pack = 'cob-results'
    if(data.reportFile.split('/').length > 1) {
      data.reportFile = data.reportFile.split('/')[2];
    } else {
      data.reportFile = data.reportFile;
    }
    this.crvtService.downloadCRVT(this.activatedRoute.snapshot.params.blueprintId, this.activatedRoute.snapshot.params.instanceId, data.runbookId,  data.reportFile, this.clientName, pack,  data.jobId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

      /** Download result */
      public downloadResult(data): void {
        this.crvtService
          .downloadCRVT(data.blueprintId,data.instanceId,data.id,data.testResultsPath,this.clientName,data.testType)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe();
      }

      /** View result */
      viewTestResults(configurationState: ConfigurationState, type?: string): void {
        if (this.pageName === "environmentSanityTest") {
          type = "SanityResults";
        }
        this.crvtService.getViewResultsUrl( configurationState.blueprintId, configurationState.instanceId,
            configurationState.id, configurationState?.testResultsPath, configurationState.tenantId, type)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((viewUrl) => {
            this.urlService.openUrlInNewTab(viewUrl);
          });
      }

    popupOpen(value, tableKey): void {
    if(this.pageName === "environmentSchedule"){
     this.dialog.open(EnvSchedulePopupComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '778px',
      height: '491px',
      autoFocus: false,
      data: {
        value: value,
        instanceId: this.activatedRoute.snapshot.params.instanceId
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        if (response) {
        }
      })
      } else if (this.pageName === "environmentJobs") {
        this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.BLUEPRINTS, this.activatedRoute.snapshot.params.blueprintId,
          RouterSegments.ENVIRONMENT, this.activatedRoute.snapshot.params.instanceId, RouterSegments.JOB, value.id],
          {
            state:
            {
              job: value
            }
          }
        );
      } else if(this.pageName === 'environmentDatabases' && tableKey !== 'ticketNumber'){
            if(value?.to?.serverName || value?.to?.fileName || value?.to?.databaseName){
            value.from.releaseVersion = value.to.releaseVersion = value?.configurationVersion;
            value.from.solutionVersion = value.to.solutionVersion = value?.solutionReleaseVersion;
            this.dialog.open(DbBackupDetailsComponent, {
              maxHeight: '99vh',
              width: '678px',
              panelClass: 'flex-dialog',
              data: value
            });
            }else{
                this.dialog.open(ErrorDialogComponent, {
                minHeight: '226px',
                width: '566px',
                panelClass: 'flex-dialog',
                data: {
                  internalError: true,
                  description: translate('INSTANCE_DETAILS.DATABASE_BACKUP_DETAILS_NOT_FOUND'),
                }
              });
            }
      } else if(this.pageName === 'environmentDatabases' && tableKey === 'ticketNumber'){
          const url = `https://itsm-servicedesk.temenos.com/browse/${value.ticketNumber}`;
          window.open(url, '_blank');
      } else if (this.pageName === 'releasePackView') {
          value.configurationState.isReleaseMismatch = this.checkReleaseMismatch(value);
          this.configNameClick.emit(value.configurationState);
      } else if (this.pageName === 'releasePackage' || this.pageName === 'rvtPackage') {
        if (this.pageName === 'releasePackage') {
          value.configuration.isReleaseMismatch = this.checkReleaseMismatch(value);
        }
        this.configNameClick.emit(value.configuration);
      } else if (this.pageName === 'rvtResults') {
        this.configNameClick.emit(value.raw);
      }
    }

    viewJobs(data) {
    this.goToJobs.emit(data);
    }

viewErrors(data): void {
    if (data?.errors?.length > 0) {
      let titleKey = '';

      if (this.pageName === 'runbook') {
      switch (data?.status) {
        case 'config_failed':
          titleKey = 'RUNBOOK.EDIT_RUNBOOK_FAILED';
          break;
        case 'delete_failed':
          titleKey = 'RUNBOOK.DELETE_RUNBOOK_FAILED';
          break;
        case 'update_failed':
          titleKey = 'RUNBOOK.UPDATE_RUNBOOK_FAILED';
          break;
        default:
          titleKey = 'RUNBOOK.CREATE_RUNBOOK_FAILED';
      }
    }

    if (this.pageName === 'environmentSchedule') {
      switch (data?.status) {
        case 'config_failed':
          titleKey = 'SCHEDULE.EDIT_SCHEDULE_FAILED';
          break;
        case 'delete_failed':
          titleKey = 'SCHEDULE.DELETE_SCHEDULE_FAILED';
          break;
        case 'update_failed':
          titleKey = 'SCHEDULE.UPDATE_SCHEDULE_FAILED';
          break;
        default:
          titleKey = 'SCHEDULE.CREATE_SCHEDULE_FAILED';
      }
    }

    if (this.pageName === 'environmentJobs') {
      titleKey = 'JOBS.COB_EXEC_FAILED';
    }

    if (this.pageName === 'environmentBaseImageDetail') {
      titleKey = 'BASE_IMAGE.UPDATE_FAILED';
    }

      this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title: translate(titleKey),
          ...(this.pageName === 'environmentBaseImageDetail' && {
            subtitle: `${translate('BASE_IMAGE.COMPONENT_FAILED')} (${(data?.errors || []).flat().length})`
          }),
          descriptionError: data?.errors
        }
      });
    }
  }
  redeployClick(data): void {
    this.redeploy.emit(data);
  }
  getRowIndex(row: any): number {
    return this.pageDataSource.data.indexOf(row);
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'env-table-scroll');
     if (this.progressTimer) clearInterval(this.progressTimer);
  }

  // to expand the table row on arrow click
  onExpandArrowClick(data): void {
    if (this.page === 'sftp') {
      const matchedRoute = this.routeWithExpiration.find(item => item.routeId === data.routeId);
      data.encKeyName = matchedRoute?.encKeyName;
      data.encKeyExpirationDate = matchedRoute?.encKeyExpirationDate;
      this.expandedElement = this.expandedElement?.routeId === data.routeId ? null : data;
      this.initialData.find(item => item.routeId === data.routeId).arrowClick = !this.initialData.find(item => item.routeId === data.routeId).arrowClick;
      this.initialData.forEach(item =>  {
        if(item.routeId !== data.routeId) {
          item.arrowClick = false;
        }
      });
    } else if (this.page === 'activity') {
        this.arrowClicked.emit(data);
    }
  }

  // showing toaster message on copy of metrics
  onCopy(field): void {
    this.toastrService.clear();
    this.toastrService.checkboxMessage(field + ' Copied')
  }

  // collapsing already expanded table when element with overlay container is opened, for avoiding opening of 2 overlay containers at once
  openMenu(): void {
    this.expandedElement = null;
    this.dataSource?.forEach(data => data.arrowClick = false);
    setTimeout(() => {
      if (document.getElementsByClassName("cdk-overlay-container")) {
        const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
        if (element) {
          element.style.display = 'block';
        }
      }
    }, 100);
  }

  // event emitter for deleting route
   deleteRoute(data): void {
    this.delete.emit(data);
  }

  /**
   * This method calls emit when user tries to edit the enc keys.
   * @param value would be the selected key data.
   */
  editKeyRoute(data): void {
    this.editKey.emit(data);
  }

  // event emitter for editing route
  editRoute(data): void {
    this.editRouteData.emit(data);
  }

  // event emitter for opening ssh key form for ssh key creation
  openSshKeyForm(data): void {
    this.openMenu();
    this.openSftpForm.emit(data);
  }

  // event emitter for viewing ssh keys
  viewSshKeys(expandedElement): void {
    this.viewSshKey.emit(expandedElement);
  }

  // checking enc key expiry status for applying color code variations
  getExpiryStatus(date?:string){
    return  new Date(date) < new Date()
  }

    openDeleteForm(dbForm): void {
        const data = {
          databases: dbForm,
          instanceName : this.instanceName
        };
        this.sidenavService.openInRightSidenav(DatabaseBackupComponent, data).
        pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(data => {
            if(data){
              this.getInstanceBackupResults();
            }
            });
      }

      extendBackup(dbForm): void {
        this.getDatabases();
        const data = {
          form: dbForm,
          instanceName : this.instance?.name,
          id: this.activatedRoute.snapshot.params.instanceId,
          subtitle: this.instance?.name,
          instance: this.instance,
          databases: this.databases,
          dbResults: this.backupResults,
          isExtendBackup: true
        };
        this.sidenavService.openInRightSidenav(DbBackupFormComponent, data).
        pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(data => {
            if(data){
              this.getInstanceBackupResults();
            }
          });
      }

    getDatabases(): void  {
      this.instanceService.getInstanceDatabases(this.activatedRoute.snapshot.params.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(response => {
          this.databases = response.databases;
          this.getInstanceBackupResults();
        },
        (error) => {
          this.getInstanceBackupResults();
          setTimeout(() => {
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
            this.toastrService.errMessage(message, title);
          }, 500);
        });

    }

    getInstanceBackupResults(): void {
      //this.isBackupTableLoaded = false;
      this.dbBackupService.getInstanceDbBackups(this.activatedRoute.snapshot.params.instanceId,)
      .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(results => {
          if (Number(results.total) > 10) {
            this.dbBackupService.getInstanceDbBackups(this.activatedRoute.snapshot.params.instanceId, results?.total)
            .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(response => {
                this.processDbData(response);
              })
          } else {
            this.processDbData(results);
          }
        },
        (error) => {
          //this.isBackupTableLoaded = true;
          setTimeout(() => {
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
            this.toastrService.errMessage(message, title);
          }, 500);
        });
    }

      processDbData(results): void {
        let sortedData;
        results.data = results?.data?.sort((a, b) => new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime());
        sortedData = results?.data;
        sortedData?.forEach(item => {
          let createdAt = new Date(item.createdAt);
          let expirationDate = new Date(item.expirationDate);
          let days = Math.floor((Date.UTC(expirationDate.getFullYear(), expirationDate.getMonth(), expirationDate.getDate()) - Date.UTC(createdAt.getFullYear(), createdAt.getMonth(), createdAt.getDate()) ) /(1000 * 60 * 60 * 24));
          item.expiryDays = days;
          if (item.status === 'completed' && (new Date(item?.expirationDate).setHours(12, 0, 0, 0) - new Date().setHours(12, 0, 0, 0) < 0)) {
            item.isExpired = true;
          }
          item.typeTag = item.from?.type?.toLowerCase()?.includes('postgresql') ? 'PostgreSQL' : item.from?.type?.toLowerCase()?.includes('sql') ? 'MSSQL' : '';
          item.dbName = this.resolveDbName(item);
        })
        this.dbInprogess = sortedData?.find(item => item.status === 'inprogress');
        this.backupResults = sortedData;
        this.backupTable = sortedData;
      }

    resolveDbName(element: any): string {
    return element?.backupType === 'archive' && element?.to?.fileName ? element?.to?.fileName : element?.backupType === 'snapshot' && element?.to?.databaseName ? element?.to?.databaseName : element?.typeTag === '	' && element?.to?.serverName ? element?.to?.serverName : 'N/A'
    }

  viewKubernetes(data): void {
    this.viewClickKubernetes.emit(data);
  }
  /**
  * This method calls when a user needs to copy the cloud resource in json format.
  */
  copyInventoryDetails(data){
    const dataInventory = {
      inventoryData: data,
      copyInventoryData: true
    };
    this.sidenavService.openInRightSidenav(CloudResourcesInventoryComponent, dataInventory);
  }

  // to get the success count from list of components
  countSuccess(data): any {
    let count = 0;
    data?.components?.forEach(element => {
      if (element.status === translate('INSTANCE_STATUS.SUCCESS')) {
        count = count + 1;
      }
    });
    return count;
  }

  // to get the failure count from list of components
  countFailure(data): any {
    let count = 0;
    data?.components?.forEach(element => {
      if (element.status === translate('INSTANCE_STATUS.FAILED')) {
        count = count + 1;
      }
    });
    return count;
  }

  // to assign class for applying background for duration value
  addClassDuration(data, status): any {
    let addColor;
    if (data.startsWith('00:')) {
      if (status === 'success') {
        addColor = 'green';
      } else {
        addColor = 'white';
      }
    } else {
      addColor = 'red';
    }
    return addColor;
  }
  downloadPackages(data, type?) {
    data.type = type ;
    this.downloadPackage.emit(data);
  }
  applyConfiguration(data) {
    this.applyPackageConfig.emit(data);
  }
  executeRvt(data){
    this.executeRvtTest.emit(data);
  }
  applyLocalConfigConfirm(data){
    this.applyLocalConfig.emit(data);
  }

  upgardeRunbookVersion(data){
    const runbookData = {
      runbookData: data
    };
    this.sidenavService.openInRightSidenav(UpdateRunbookVersionComponent, runbookData)
      .subscribe(result => {
        if (result?.updated) {
          this.dataLoading = true;
          this.showSkeletonLoader = true;
          setTimeout(() => {
          this.updateRunbookEmit.emit();
          }, 1000);
        }
      });
  }

  // collapsing already expanded table when element with overlay container is opened, for avoiding opening of 2 overlay containers at once
  openSizingMenu(): void {
    this.expandedElement = null;
    this.dataSource?.forEach(data => data.arrowClick = false);
    setTimeout(() => {
      if (document.getElementsByClassName("cdk-overlay-container")) {
        const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
        if (element) {
          element.style.display = 'block';
        }
      }
    }, 100);
  }

  // event emitter for deleting sizing record
  deleteSizing(data): void {
    this.deleteSizingData.emit(data);
  }

  // event emitter for editing sizing
  editSizing(data): void {
   this.editSizingData.emit(data);
  }

  // event emitter for applying sizing document
  applySizing(data): void {
    this.applySizingDoc.emit(data);
  }
  // event emitter for threshold details
  openThresholdDialog(data: { componentName: string; start: string; expectedDurationMs: number }): void {
    this.thresholdClick.emit(data);
  }

  openExternalLink(pipelineId: string): void {
    if (pipelineId) {
      const adoUrl = this.urlService.buildADOPipelineUrl(pipelineId);

      if (adoUrl) {
        const dialogData = {
          redirectTitle: translate('ADD_INSTANCE.ADO_PIPELINE'),
          redirectMsg: translate('INSTANCE_DETAILS.ADO_PIPELINE'),
          proceedButtonText: translate('BUTTONS.PROCEED')
        };
        this.matDialog.open(RedirectionDialogComponent, {
          panelClass: 'default-dialog-wrapper',
          width: '566px',
          autoFocus: false,
          data: dialogData,
          disableClose: false
        }).afterClosed().subscribe(result => {
          if (result) {
            window.open(adoUrl, '_blank');
          }
        });
      }
    }
  }
  
  showLocationDetail(index: number, row: any): boolean {
    return row?.showLocation;
  }

  private checkReleaseMismatch(data): boolean {
    if (data?.references) {
      let instanceReferenceVersion = data?.references?.packages.find(item => item.name?.includes('tap'))?.name?.split('-')[3];
      return instanceReferenceVersion !== data?.configuration?.instance?.version;
    }
    return false;
  }

  private getReleaseMismatchTooltipText(data): string {
    let instanceReferenceVersion = data?.references?.packages.find(item => item.name?.includes('tap'))?.name?.split('-')[3];
    let solutionVersion = data?.configuration?.instance?.version;
    if (instanceReferenceVersion && solutionVersion) {
      return translate('BLUEPRINT_SUMMARY.RELEASE_MISMATCH_TOOLTIP').replace(/solutionVersion/g, solutionVersion).replace(/referenceVersion/g, instanceReferenceVersion);
    }
    return '';
  }
}
